import { Injectable } from '@angular/core';

import { Api, User  } from '../';

@Injectable()
export class Tracking {

  active = 0;
  review = 0;
  data:any = {};
  
  constructor(public api: Api, public user:User) { }

  get(params?: any) {
    return this.api.get('index.php/asset/tracking', params);
  }

  post(params?: any) {
    if(params.id>0){
      params.updated_by = this.user.data.employee_id;
    }else{
      params.created_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/asset/tracking', params);
  }

  get_location(params?: any) {
    return this.api.get('index.php/asset/tracking/location', params);
  }

  post_location(params?: any) {
    params.tracking_id = this.data.id;
    params.user_id = this.user.data.user_id;
    return this.api.post('index.php/asset/tracking/location', params);
  }

  getTrackingLocation(params){
    return this.api.get('index.php/asset/tracking/log_location', params);
  }

  get_item(params?: any) {
    return this.api.get('index.php/asset/tracking/item', params);
  }

  post_item(params?: any) {
    params.tracking_id = this.data.id;
    if(params.id>0){
      params.updated_by = this.user.data.employee_id;
    }else{
      params.created_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/asset/tracking/item', params);
  }

  get_tracked_item(params?: any){
    return this.api.get('index.php/asset/tracking/tracked_item', params);
  }

}



// WEBPACK FOOTER //
// ./src/providers/asset/tracking/tracking.ts